import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../lib/constants";

export const FloatingWhatsApp = () => {
  return (
    <motion.a
      href={CONTACT.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.5 }}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3 shadow-2xl hover:scale-105 transition-transform animate-pulse-soft"
      aria-label="Peça agora pelo WhatsApp"
      data-testid="floating-whatsapp"
    >
      <MessageCircle size={22} fill="currentColor" strokeWidth={0} />
      <span className="font-semibold text-sm hidden sm:inline">Peça agora</span>
    </motion.a>
  );
};

export default FloatingWhatsApp;
